import { useCallback, useMemo } from "react"
import { useActiveWeb3React } from '../'
import { getContract } from '../../utils/bakery/erc20'
import { provider } from 'web3-core'
import { approve } from '../../sushi/utils'
import useYam from "../bakery/useYam"
import { userTokenAddress } from '../../userType/userTokenAddress'
import { userBidNFTContract } from '../../userType/userBidNFTContract'
import { MARKETTYPE, MARKETMULTITOKEN, MARKETTYPEV1, MARKETTYPEV3 } from '../../constants/bakery/nft'
import { multiTokenExchangeNftContract } from '../../userType/multiTokenExchangeNftContract'
import { userExchangeNFTContract } from "../../userType/userExchangeNFTContract"
import { userV3NFTContract } from "../../userType/userV3NFTContract"

const useApproveBid = (type?: string, tokenName?: string) => {
  const { account, library } = useActiveWeb3React()
  const ethereum = library?.provider
  const sushi = useYam()
  let lpTokenAddress = userTokenAddress(sushi, tokenName)
  const lpContract = useMemo(() => {
    return getContract(ethereum as provider, lpTokenAddress)
  }, [ethereum, lpTokenAddress])

  let contract: any
  if(type && MARKETTYPE.hasOwnProperty(type)){
    contract = userBidNFTContract(sushi, type)
  }else if(type && MARKETMULTITOKEN.hasOwnProperty(type)){
    contract = multiTokenExchangeNftContract(sushi, type)
  }else if(type && MARKETTYPEV1.hasOwnProperty(type)){
    contract = userExchangeNFTContract(sushi, type)
  }else if(type && MARKETTYPEV3.hasOwnProperty(type)){
    contract = userV3NFTContract(sushi, type)
  }

  const handleApprove = useCallback(async () => {
    try {
      const tx = await approve(lpContract, contract, account)
      return tx
    } catch (e) {
      console.log('useApproveBid-->>', e)
      return false
    }
  }, [account, lpContract, contract])

  return handleApprove
}

export default useApproveBid